import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});
